import React from 'react';
import { Download } from '@mui/icons-material';

export const DownloadDistributorClientsOptions = {
  CLIENTS_WITH_ACTIVE_CONTRACTS: 'CLIENTS_WITH_ACTIVE_CONTRACTS',
  CLIENTS_WITH_ENDED_CONTRACTS: 'CLIENTS_WITH_ENDED_CONTRACTS',
  ALL_CLIENTS: 'ALL_CLIENTS'
};

export const DownloadDistributorClientsMenuOptions = [
  {
    label: 'COMMON.CLIENTS_WITH_ACTIVE_CONTRACTS',
    key: DownloadDistributorClientsOptions.CLIENTS_WITH_ACTIVE_CONTRACTS,
    icon: <Download />
  },
  {
    label: 'COMMON.CLIENTS_WITH_ENDED_CONTRACTS',
    key: DownloadDistributorClientsOptions.CLIENTS_WITH_ENDED_CONTRACTS,
    icon: <Download />
  },
  {
    label: 'COMMON.ALL_CLIENTS',
    key: DownloadDistributorClientsOptions.ALL_CLIENTS,
    icon: <Download />
  }
];

export const selectDownloadDistributorClientsOptions = () => {
  return DownloadDistributorClientsMenuOptions;
};
